import React from "react";
import Dropzone from "../blocks/editable/Dropzone";
import { FiUploadCloud } from "react-icons/fi";
import { MdOutlineFileUpload } from "react-icons/md";


export default class NewUpload extends React.Component {
  constructor(props) {
    super(props);

    this.state = {

    };

    this.dropzone = React.createRef()
  }

  _onUploaded(image){
    this.setState({ isLoading: false })
    this.props.onUploaded(image)
  }

  render() {
    return (
      <div className="new-upload">

        <Dropzone
          ref={this.dropzone}
          type="photo"
          onUploaded={image => this._onUploaded(image)}
          inputContent={
            <div className="input-content">
              <FiUploadCloud className="i-upload" />
              <div>Select file or drag and drop here</div>
              <button className="btn btn--secondary btn--icon btn--sm"><i class="icon"><MdOutlineFileUpload /></i>Choose File</button>
            </div>
          }
        />

        <dl>
          <dt>Important Notice:</dt>
          <dd>Using WebP images may lead to faster page speeds!</dd>
          <dd>WebP is an image format with superior compression and quality compared to JPEG and PNG. Using WebP rather than JPEG or PNG means your images will load faster and consume less cellular data.</dd>
          <dd>Learn more here: <a href="https://developers.google.com/speed/webp" target="blank" >WebP Image Format</a></dd>
        </dl>

      </div>
    )
  }

}
